import { render, staticRenderFns } from "./DataProductsDrawerDataAssetsTab.vue?vue&type=template&id=b7e31156&scoped=true&lang=pug"
import script from "./DataProductsDrawerDataAssetsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProductsDrawerDataAssetsTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataProductsDrawerDataAssetsTab.vue?vue&type=style&index=0&id=b7e31156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e31156",
  null
  
)

export default component.exports